import { ROUTE } from "../../routes";
export const goToPhoto = async (action, _datastore, { navigate }) => {
    console.warn("*** goToPhoto ***", action);
    await navigate(ROUTE.CAMERA_CAPTURE);
};
export const goToSupportDoc = async (action, _datastore, { navigate }) => {
    console.warn("*** goToSupportDoc ***", action);
    await navigate(ROUTE.SUPPORTING_DOCUMENT);
};
export const goBack = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.KYC_PHOTO_VERIFICATION);
};
